module.exports = __webpack_public_path__ + "static/media/kintosol-banner.0d832435.jpg";